import { datadogRum } from '@datadog/browser-rum';
import { config } from '@mytaxi/config-store';

export const initializeDatadog = () => {
    datadogRum.init({
        clientToken: config.getItem('datadog.clientToken'),
        applicationId: config.getItem('datadog.applicationId'),
        site: 'datadoghq.eu',
        service: config.getItem('datadog.service'),
        env: config.getItem('environment'),
        version: process.env.REACT_APP_VERSION,
        allowedTracingUrls: [
            (url) => url.startsWith(config.getItem('apgsUrl')),
            (url) => url.startsWith(config.getItem('wagsUrl')),
        ],
        sessionSampleRate: 100,
        sessionReplaySampleRate: 20,
        trackResources: true,
        trackLongTasks: true,
        trackUserInteractions: true,
        enablePrivacyForActionName: true,
        defaultPrivacyLevel: 'mask-user-input',
    });
};
